import React from 'react';
import { Box, Typography } from '@mui/material';

interface StatusLabelProps {
  label: string;
  backgroundColor: string;
  textColor: string;
  icon?: React.ReactNode;
  borderRadius?: string | number;
  padding?: string | number;
  gap?: string | number;
}

const StatusLabel: React.FC<StatusLabelProps> = ({
  label,
  backgroundColor,
  textColor,
  icon,
  borderRadius = '4px',
  padding = '4px 8px',
  gap = '8px',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        backgroundColor,
        color: textColor,
        borderRadius,
        padding,
        gap,
        fontFamily: 'IRANYekanXFaNum',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '15.6px',
        direction: 'rtl',
      }}
    >
      {icon && <span>{icon}</span>}
      <Typography variant="body2" sx={{ color: textColor }}>
        {label}
      </Typography>
    </Box>
  );
};

export default StatusLabel;
